window.VegasSelect2 = {
	init: function () {
		let $select2 = $('body').find('[data-toggle=select2]');

		$select2.each(function (i, e) {
			VegasSelect2.select2(e);
		});
	},

	select2: function (select) {
		let plugin_option = $(select).data('plugin-options');

		let select2_option = $.extend({
			theme: "bootstrap",
			language: "ru",
		}, plugin_option || {});

		$(select).select2(select2_option);
	}
};

$(document).ready(function () {
	VegasSelect2.init();
});